import { range } from 'lodash';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { mapActions, mapGetters } from 'vuex';
import { MarketLoader as marketLoader } from '@/components/content-loader';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';

export default {
  components: {
    marketListItem: marketListItemV2,
    marketLoader,
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
  props: {
    num: { type: Number, default: 3 },
  },
  data() {
    return {
      isComponentReady: false,
      activeIndex: 0,
      swiperInstance: null,
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        direction: 'horizontal',
        spaceBetween: 0,
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapGetters('widgets', ['getWidget']),
    widget() {
      return this.getWidget('new-arrivals');
    },
    items() {
      return (this.widget.data || []).slice(0, this.num);
    },
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      return range(0, this.num);
    },
    prevArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'most-predicted-list__header-arrow': true,
        'most-predicted-list__header-arrow--right': true,
      };
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchNewArrivals']),
    onSwiperReady(swiperInstance) {
      this.swiperInstance = swiperInstance;
    },
    onTransitionStart(swp) {
      this.activeIndex = swp.activeIndex;
    },
    prevSlide() {
      this.swiperInstance.slidePrev();
    },
    nextSlide() {
      this.swiperInstance.slideNext();
    },
  },
  mounted() {
    this.fetchNewArrivals({ limit: this.num }).then(() => {
      this.isComponentReady = true;
    });
  },
};
